import * as types from 'actions/actionTypes';
import initialState from './initialState';
import * as miscServices from 'services/miscServices';

/**
 * reducer per gestire le userActions
 * @param {*} state
 * @param {*} action
 */
export default function userReducer(state = initialState.user, action){
    var accountList = [];
    var rootAccount;
    var account;

    switch(action.type)
    {
        case types.USER_LOGGING_IN:
            return {...state, isAuthenticated: false, isAuthenticating: true, currentUser: null};
        case types.USER_LOGIN_ERROR:
            return {...state, isAuthenticated: false, isAuthenticating: false, currentUser: null, accountList: [], authError: action.error};
        case types.USER_LOGGED_IN:
            return {...state, isAuthenticated: true, isAuthenticating: false};
        case types.USER_LOGGED_OUT:
            return {...state, isAuthenticated: false, isAuthenticating: false};

        case types.LOAD_CURRENTUSER_REQUEST:
            return {...state, currentUser: null, accountList: []};
        case types.LOAD_CURRENTUSER_SUCCESS:

            /*
                tutti gli utenti appartengono ad almeno un account
            */
            rootAccount = miscServices.getRootAccountForSelector(action.data.account);
            accountList.push(rootAccount);
            return {...state, currentUser: action.data, accountList};

        case types.LOAD_INIT_CURRENTUSER_REQUEST:
            return {...state, isAuthenticated: false, currentUser: null, accountList, isAuthenticating: true};

        case types.LOAD_INIT_CURRENTUSER_SUCCESS:

            /*
                tutti gli utenti appartengono ad almeno un account
            */
            rootAccount = miscServices.getRootAccountForSelector(action.data.account);
            accountList.push(rootAccount);
            return {...state, currentUser: action.data, accountList, isAuthenticated: true, isAuthenticating: false};
        case types.LOAD_INIT_CURRENTUSER_ERROR:
            console.info("LOAD_INIT_CURRENTUSER_ERROR", action);
            return {...state, isAuthenticated: false, currentUser: null, isAuthenticating: false};

        case types.FETCH_SUBACCOUNTS_REQUEST:
            accountList = miscServices.copyRecursiveAccountItemSelector(state.accountList);
            account = miscServices.getItemFromListById(accountList, action.data.parentId);
            account.isLoading = true;

            return {...state, accountList };
        case types.FETCH_SUBACCOUNTS_ERROR:
            accountList = miscServices.copyRecursiveAccountItemSelector(state.accountList);
            account = miscServices.getItemFromListById(accountList, action.data.parentId);
            account.isLoading = false;

            return {...state, accountList };
        case types.FETCH_SUBACCOUNTS_SUCCESS:

            /*
                clono la lista, slice non funziona, ...state nemmeno
            */
            accountList = miscServices.copyRecursiveAccountItemSelector(state.accountList);

            var i;
            var parentAccount = miscServices.getItemFromListById(accountList, action.data.parentId);

            if(!parentAccount) {
                throw new Error("Root account not found");
            }

            if(!parentAccount.children) {
                throw new Error("Root account is not instantiated");
            }

            if(action.data.subAccounts)
            {
                for (i = 0; i < action.data.subAccounts.length; i++) {
                    var currentIndex = accountList.length;
                    var childrenAccount = miscServices.getAccountForSelector(action.data.subAccounts[i], parentAccount, currentIndex);
                    parentAccount.children.push(childrenAccount);
                }

                parentAccount.isOpened = true;
            }
            else{
                parentAccount.children = [];
            }

            /*
                salvo l'item come non più da cercare in calAmp
            */
            parentAccount.hasBeenLoaded = true;
            parentAccount.isLoading = false;

            return {...state, accountList };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/userReducer.js